import { MobObject } from './mobobject';

export class NpcObject extends MobObject {
    eventVar: any;
    dialogIdx: any;
    ingStatus: any;
    isVendingProp: boolean;
    vendingOwnerObjectIdx: number | undefined;

    constructor(world: any) {
      super(world);
      this.type = 'npc';
      this.eventVar = {};
      this.dialogIdx = undefined;
      this.ingStatus = undefined;
      this.isVendingProp = false;
      this.vendingOwnerObjectIdx = undefined;
    }

    setEventVar(id: any, value: any) {
      this.eventVar[id] = value;
    }

}

/**
 * @constructor
 */



